module.exports = __webpack_public_path__ + "static/media/empty-order.1081ce2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/payment/empty-order.png
// module id = 653
// module chunks = 0